export default "__VITE_ASSET__zTQIfAva__"